import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../api/axiosInstance";
import { useParams } from "react-router-dom";


export default function SurgicalPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  
  
const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [item, setItem] = useState({
    name: "",
    company: "",
    type: "",
    selling_price: "",
    purchase_price: "",
    mrp: "",
    gst_percent: "",
    stock: "",
    expiry_date: "",
    image: null,
    image_url: "",
  });

  // --------------------------
  // FETCH EXISTING DATA (EDIT MODE)
  // --------------------------
  useEffect(() => {
    if (!id) return;

    const fetchItem = async () => {
      setLoading(true);
      try {
        const res = await api.get(`surgical/${id}/`);
        const data = res.data;

        // fix expiry date → convert to YYYY-MM-DD format
        let fixedDate = "";
        if (data.expiry_date) {
          try {
            const d = new Date(data.expiry_date);
            if (!isNaN(d)) {
              fixedDate = d.toISOString().split("T")[0];
            }
          } catch {}
        }

        setItem({
          ...data,
          expiry_date: fixedDate,
          image_url: data.image ? data.image : "",
        });

      } catch (error) {
        alert("Failed to load surgical item");
        console.log(error);
      }
      setLoading(false);
    };

    fetchItem();
  }, [id]);

  // --------------------------
  // HANDLE INPUT CHANGE (including expiry date validation)
  // --------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;

    // YEAR FIX → Ensure year is only 4 digits
    if (name === "expiry_date") {
      const parts = value.split("-");
      if (parts[0] && parts[0].length > 4) {
        parts[0] = parts[0].slice(0, 4);
      }
      return setItem({ ...item, expiry_date: parts.join("-") });
    }

    setItem({ ...item, [name]: value });
  };

  // --------------------------
  // IMAGE PICK HANDLER
  // --------------------------
useEffect(() => {
    if (!id) return;

    api.get(`/surgical/${id}`).then((res) => {
        const data = res.data;

        console.log("🔥 FULL API RESPONSE =", data);   // <-- SEND ME THIS

        if (data.image) {
            console.log("IMAGE FROM API =", data.image);
        } else {
            console.log("⚠ NO IMAGE FOUND IN API");
        }

        // Fix image path
        if (data.image && !data.image.startsWith("http")) {
            if (data.image.startsWith("/media")) {
                data.image = `http://127.0.0.1:8000${data.image}`;
            } else {
                data.image = `http://127.0.0.1:8000/media/${data.image}`;
            }
        }

        setItem(data);
    });
}, [id]);

const handleImagePick = (e) => {
    const file = e.target.files[0];
    if (file) {
        setItem({ ...item, image: file });
    }
};



  // --------------------------
  // SAVE / UPDATE SURGICAL ITEM
  // --------------------------
  const handleSave = async () => {
    setSaving(true);

    try {
      const payload = {
        name: item.name,
        company: item.company,
        type: item.type,
        selling_price: item.selling_price,
        purchase_price: item.purchase_price,
        mrp: item.mrp,
        gst_percent: item.gst_percent,
        stock: item.stock,
        expiry_date: item.expiry_date || null,
      };

      let res;

      // Update existing item
      if (id) {
        res = await api.put(`surgical/${id}/update/`, payload);
      } 
      // Create new item
      else {
        res = await api.post(`surgical/create/`, payload);
      }

if (item.image && item.image instanceof File) {
  const formData = new FormData();
  formData.append("image", item.image);

  await api.put(
    `surgical/${id || res.data.id}/update-image/`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
}

      alert("Saved successfully!");
      navigate("/admin");

    } catch (error) {
      console.log(error);
      alert("Save failed, please check values.");
    }

    setSaving(false);
  };

  if (loading) return <p style={{ padding: 20 }}>Loading...</p>;

  return (
    <div style={{ padding: 20, maxWidth: 600, margin: "auto" }}>
      <button
        style={{ marginBottom: 20 }}
        onClick={() => navigate("/admin/surgical-excel")}
      >
        ← Back
      </button>

      <h2>{id ? "Edit Surgical Item" : "Add Surgical Item"}</h2>

      {/* IMAGE UPLOAD BOX */}
 <div
  onClick={() => document.getElementById("imageInput").click()}
  style={{
    width: 160,
    height: 160,
    background: "#eee",
    borderRadius: 10,
    border: "1px solid #ccc",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    marginBottom: 10,
    overflow: "hidden",
  }}
>
  {item.image ? (
    typeof item.image === "string" ? (
      <img
        src={item.image}
        alt="preview"
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    ) : (
      <img
        src={URL.createObjectURL(item.image)}
        alt="preview"
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    )
  ) : (
    "Tap to upload image"
  )}
</div>


      <input
        type="file"
        id="imageInput"
        style={{ display: "none" }}
        accept="image/*"
        onChange={handleImagePick}
      />

      {/* FORM FIELDS */}
      {[
        ["name", "Item Name"],
        ["company", "Company"],
        ["type", "Type (Gloves/Mask/Cannula etc.)"],
        ["selling_price", "Selling Price"],
        ["purchase_price", "Purchase Price"],
        ["mrp", "MRP"],
        ["gst_percent", "GST %"],
        ["stock", "Stock"],
      ].map(([field, label]) => (
        <div key={field} style={{ marginBottom: 10 }}>
          <label>{label}</label>
          <input
            type="text"
            name={field}
            value={item[field]}
            onChange={handleChange}
            style={styles.input}
          />
        </div>
      ))}

      {/* EXPIRY DATE */}
      <div style={{ marginBottom: 10 }}>
        <label>Expiry Date</label>
        <input
          type="date"
          name="expiry_date"
          value={item.expiry_date}
          onChange={handleChange}
          style={styles.input}
          max="2099-12-31"   // prevents 6-digit year bug
        />
      </div>

      <button
        onClick={handleSave}
        disabled={saving}
        style={styles.saveBtn}
      >
        {saving ? "Saving..." : id ? "Update Surgical Item" : "Add Surgical Item"}
      </button>
    </div>
  );
}

const styles = {
  input: {
    width: "100%",
    padding: 10,
    borderRadius: 6,
    border: "1px solid #ccc",
  },
  saveBtn: {
    width: "100%",
    padding: 14,
    background: "#0066ff",
    color: "white",
    border: "none",
    borderRadius: 8,
    fontWeight: "bold",
    cursor: "pointer",
    marginTop: 15,
  },
};
